<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu :menuMobile="true"></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-5 col-lg-6 col-md-8 col-sm-9 col-12 forms">
          <form action="">
            <div class="text-center custom-col">
              <h1 class="title-view-2 mb-1">Recover Password</h1>
              <div class="textInHorizontalLine">
                <span>Suppliers</span>
              </div>
            </div>
            <div class="card pb-3 mt-4 mb-2">
              <form>
                <div class="card-body">
                  <input hidden type="text" autocomplete="username" value="" />
                  <span class="d-block f2 text-center mb-4"
                    >Enter a new password to recover your account</span
                  >
                  <div class="col-12">
                    <base-input
                      label="Password"
                      class="input-append"
                      placeholder="Password"
                      v-model="data.password"
                      autocomplete="new-password"
                      :type="inputType"
                      :successMessage="'Strong Password'"
                      :valid="$v.data.password.strongPassword"
                      :tooltip="true"
                      titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                      contentTooltip='<ul class="ul-pop">
                                  <li>Minimum 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                      :error="
                        validatePassword(
                          $v.data.password.minLength,
                          $v.data.password.$error,
                          $v.data.password.$params,
                          $v.data.password.$model,
                          $v.data.password.required
                        )
                      "
                      indexTab="1"
                      :focusact="true"
                      markrequired
                      ><template slot="append">
                        <span @click="seePassword()" class="icon-button"
                          ><i
                            v-bind:class="{
                              'flaticon-view-1': inputType == 'password',
                              'flaticon-hidden': inputType == 'text'
                            }"
                          ></i
                        ></span> </template
                    ></base-input>
                  </div>
                  <div class="col-12">
                    <base-input
                      label="Password Confirmation"
                      placeholder="Password Confirmation"
                      v-model="data.repeatPassword"
                      type="password"
                      indexTab="2"
                      markrequired
                      autocomplete="new-password"
                      :error="
                        !$v.data.repeatPassword.sameAsPassword ||
                        $v.data.repeatPassword.$error
                          ? `Passwords must be identical.`
                          : ''
                      "
                    ></base-input>

                    <div class="text-center">
                      <base-button
                        type="primary"
                        class="min-button"
                        @click="savePassword()"
                        tabindex="3"
                        >Accept</base-button
                      >
                    </div>
                  </div>

                  <div class="loading mt-3" v-if="load">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </form>
            </div>
          </form>
        </div>
      </div>
    </div>
    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>

<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import Swal from "sweetalert2";
import endpoint from "../Commons/Services/index";
import layoutFooter from "../Layout/ContentFooter";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      data: {
        password: "",
        repeatPassword: ""
      },
      load: false,
      userType: "",
      token: "",
      userId: "",
      inputType: "password"
    };
  },
  created() {
    this.userId = this.$route.query.userId ? this.$route.query.userId : null;
    this.userType = this.$route.query.userType
      ? this.$route.query.userType
      : null;
    this.operation = this.$route.query.operation
      ? this.$route.query.operation
      : null;
    this.token = this.$route.query.token ? this.$route.query.token : "";
  },
  methods: {
    async savePassword() {
      this.$v.data.$touch();
      if (!this.$v.data.$invalid) {
        this.load = true;
        try {
          let { data } = await endpoint.auth.services.restorePassword(
            this.userId,
            this.userType,
            this.operation,
            this.data,
            this.token
          );
          if (data.status) {
            this.load = false;
            let result = await Swal.fire({
              title: "Success",
              html: "You can now log in with your new password",
              imageUrl: require("rhomtrip_assets/src/img/icons/alerts/success.png"),
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              confirmButtonClass: "btn btn-primary btn-small-one"
            });

            if (result.value) {
              this.$router.push("/");
            } else {
              this.$router.push("/");
            }
          } else {
            this.load = false;
            let result = await Swal.fire({
              title: "Error",
              html:
                'An error occurred while saved your changes,<br> try again or <a href="https://www.rhomtrip.com/contact" target="blank">Contact us</a>',
              imageUrl: require("rhomtrip_assets/src/img/icons/alerts/error.png"),
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              confirmButtonClass: "btn btn-primary btn-small-one"
            });
            if (result.value) {
              this.$router.push("/");
            } else {
              this.$router.push("/");
            }
          }
        } catch (error) {
          this.load = false;
          let result = await Swal.fire({
            title: "Error",
            html:
              'An error occurred while saved your changes,<br> try again or <a href="https://www.rhomtrip.com/contact" target="blank">Contact us</a>',
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/error.png"),
            buttonsStyling: false,
            focusConfirm: false,
            reverseButtons: true,
            confirmButtonText: "Accept",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (result.value) {
            this.$router.push("/");
          } else {
            this.$router.push("/");
          }
        }
      }
    },
    validatePassword($minLength, $error, $params, $model, $required) {
      if ($error) {
        if (!$minLength) {
          return `Minimum 8 Characters.`;
        } else if ($required && $model.length < 1) {
          return `Enter a Password`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    seePassword() {
      this.inputType = this.inputType == "password" ? "text" : "password";
    }
  },
  validations: {
    data: {
      password: {
        required,
        minLength: minLength(8),
        strongPassword(password) {
          return (
            /[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          );
        }
      },
      repeatPassword: {
        sameAsPassword: sameAs("password")
      }
    }
  }
};
</script>
